import { downloadCrashPackageZip } from './download-crash-package-zip'
import { enqueueFinalSync } from './sync-queue-helpers'
import { upsertLocalIncident } from './incident-store'

/**
 * Persistenza IndexedDB + coda sync, poi download ZIP immediato (PRO-136 2A).
 * Se il download fallisce, IndexedDB e coda restano comunque aggiornati.
 *
 * @param {Object} params
 * @param {string} params.clientUuid
 * @param {object} params.payload
 * @param {Record<string, unknown> | null} params.formModel
 * @param {string | number} params.createdByUserId
 * @param {string | null | undefined} params.bearer
 * @returns {Promise<{ downloadOk: boolean, downloadError: Error | null }>}
 */
export async function saveOfflineCrashAndDownload({
  clientUuid,
  payload,
  formModel,
  createdByUserId,
  bearer,
}) {
  await upsertLocalIncident(clientUuid, payload, 'queued')
  await enqueueFinalSync(clientUuid, payload)

  try {
    await downloadCrashPackageZip({
      rows: [{ clientUuid, payload }],
      formModel,
      createdByUserId,
      bearer,
    })
    return { downloadOk: true, downloadError: null }
  } catch (error) {
    const downloadError =
      error instanceof Error ? error : new Error(String(error))
    return { downloadOk: false, downloadError }
  }
}
